export default __webpack_public_path__ + "static/media/scour_info.f90e2918.png";